Ext.define('SA.view.ImportFileList', {
    alias: 'widget.import-file-list',
    extend: 'SA.view.SimpleContainer',

    baseCls: 'sa-import-file-list',

    initComponent() {
        this.callParent();

        this.addItem();
    },

    addItem() {
        this.add({
            xtype: 'import-file-list-item',
            geographicUnits: this.geographicUnits,

            listeners: {
                'click:remove': item => this.onRemoveItemClick(item)
            }
        });

        this.refreshFirstItemRemovable();
        this.fireItemCountChange();
    },

    fireItemCountChange() {
        this.fireEvent('change:itemCount');
    },

    async getValue() {
        var items = this.getChildItems(),
            getValue = item => item.getValue(),
            values = await Promise.all(items.map(getValue));

        return values.filter(value => !!value);
    },

    hasSingleItem() {
        return this.getChildItems().length === 1;
    },

    initEvents() {
        this.callParent();
    },

    onRemoveItemClick(item) {
        this.remove(item);

        this.refreshFirstItemRemovable();
        this.fireItemCountChange();
    },

    refreshFirstItemRemovable() {
        this.items[0].setRemovable(this.items.length > 1);
    },

    setGeographicUnits(geographicUnits) {
        this.geographicUnits = geographicUnits;

        this.getChildItems().forEach(item => item.setGeographicUnits(geographicUnits));
    }
});
